<template>
  <div class="patrones-container p-1 p-md-2">
    <!-- ================= NIVEL SOBRES ================= -->
    <b-card v-if="!sobreActivo">
      <b-row class="mb-2" align-v="center">
        <b-col cols="12" md="auto" class="d-flex align-items-center mb-1 mb-md-0">
          <h4 class="mb-0 flex-grow-1">Patrones</h4>
          <b-button variant="flat-secondary" class="btn-icon mr-50" :title="tituloImpresora" @click="abrirImpresora">
            <i class="fa-solid fa-print" :class="impresora.host ? 'text-success' : 'text-muted'"></i>
          </b-button>
          <b-button class="d-md-none btn-icon" variant="primary" @click="abrirNuevoSobre"><i class="fa-solid fa-plus"></i></b-button>
        </b-col>
        <b-col cols="12" md class="mb-1 mb-md-0">
          <b-input-group>
            <b-input-group-prepend is-text><i class="fa-solid fa-magnifying-glass"></i></b-input-group-prepend>
            <b-form-input v-model="busqueda" placeholder="Buscar sobre..." />
            <b-input-group-append v-if="busqueda">
              <b-button variant="outline-secondary" @click="busqueda = ''"><i class="fa-solid fa-xmark"></i></b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col cols="auto" class="d-none d-md-block">
          <b-button variant="primary" @click="abrirNuevoSobre">
            <i class="fa-solid fa-plus mr-50"></i> Nuevo sobre
          </b-button>
        </b-col>
      </b-row>

      <!-- Lista de sobres -->
      <div>
        <div v-if="cargando" class="text-center py-3"><b-spinner /></div>
        <div v-else-if="sobres.length === 0" class="text-muted text-center py-3">No hay sobres todavía.</div>
        <div v-else-if="sobresFiltrados.length === 0" class="text-muted text-center py-3">Sin coincidencias.</div>
        <b-row v-else>
          <b-col v-for="s in sobresFiltrados" :key="s.id" lg="3" md="4" sm="6" class="mb-2">
            <b-card no-body class="patron-card h-100">
              <div class="patron-card-cover" @click="abrirSobre(s)">
                <b-img v-if="s.portada" :src="fotoUrl(s.portada)" class="patron-card-img" />
                <div v-else class="patron-card-img patron-card-empty"><i class="fa-solid fa-folder-open"></i></div>
                <b-badge class="patron-card-count" variant="primary">{{ s.numPatrones }}</b-badge>
              </div>
              <div class="p-1" @click="abrirSobre(s)" style="cursor:pointer">
                <div class="font-weight-bold text-truncate">{{ s.nombre }}</div>
                <code class="small">{{ s.codigo }}</code>
              </div>
              <div class="patron-card-bar">
                <b-button size="sm" variant="flat-secondary" class="btn-icon" title="Código RFID" @click="abrirRfid(s)"><i class="fa-solid fa-barcode"></i></b-button>
                <b-button size="sm" variant="flat-secondary" class="btn-icon" title="Imprimir" @click="imprimir([{ rfid: s.rfid, codigo: s.codigo, sobre: s.nombre }])"><i class="fa-solid fa-print"></i></b-button>
                <b-button size="sm" variant="flat-primary" class="btn-icon" title="Renombrar" @click="abrirRenombrarSobre(s)"><i class="fa-solid fa-pen"></i></b-button>
                <b-button size="sm" variant="flat-danger" class="btn-icon" title="Eliminar" @click="borrarSobre(s)"><i class="fa-solid fa-trash"></i></b-button>
              </div>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </b-card>

    <!-- ================= NIVEL PATRONES ================= -->
    <b-card v-else>
      <b-row class="mb-2" align-v="center">
        <b-col cols="12" md="auto" class="d-flex align-items-center mb-1 mb-md-0">
          <b-button variant="flat-secondary" class="btn-icon mr-50" @click="volverSobres"><i class="fa-solid fa-arrow-left"></i></b-button>
          <div class="flex-grow-1 min-w-0">
            <h4 class="mb-0 text-truncate">{{ sobreActivo.nombre }}</h4>
            <code class="small">{{ sobreActivo.codigo }}</code>
          </div>
          <b-button class="d-md-none btn-icon" variant="primary" @click="abrirNuevoPatron"><i class="fa-solid fa-plus"></i></b-button>
        </b-col>
        <b-col cols="12" md class="mb-1 mb-md-0">
          <b-input-group>
            <b-input-group-prepend is-text><i class="fa-solid fa-magnifying-glass"></i></b-input-group-prepend>
            <b-form-input v-model="busquedaPatron" placeholder="Buscar patrón en este sobre..." />
            <b-input-group-append v-if="busquedaPatron">
              <b-button variant="outline-secondary" @click="busquedaPatron = ''"><i class="fa-solid fa-xmark"></i></b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col cols="auto" class="d-none d-md-block">
          <b-button variant="primary" @click="abrirNuevoPatron">
            <i class="fa-solid fa-plus mr-50"></i> Nuevo patrón
          </b-button>
        </b-col>
      </b-row>

      <div v-if="cargando" class="text-center py-3"><b-spinner /></div>
      <div v-else-if="patrones.length === 0" class="text-muted text-center py-3">Este sobre no tiene patrones.</div>
      <div v-else-if="patronesFiltrados.length === 0" class="text-muted text-center py-3">Sin coincidencias.</div>

      <b-row v-else>
        <b-col v-for="p in patronesFiltrados" :key="p.id" lg="3" md="4" sm="6" class="mb-2">
          <b-card no-body class="patron-card h-100">
            <div class="patron-card-cover" @click="abrirPatron(p)">
              <b-img v-if="p.foto" :src="fotoUrl(p.foto)" class="patron-card-img" />
              <div v-else class="patron-card-img patron-card-empty"><i class="fa-solid fa-scissors"></i></div>
            </div>
            <div class="p-1" @click="abrirPatron(p)" style="cursor:pointer">
              <div class="font-weight-bold text-truncate">{{ p.nombre }}</div>
              <code class="small">{{ p.codigo }}</code>
              <div class="mt-25">
                <b-badge variant="light-secondary">{{ p.numAnotaciones }} notas</b-badge>
              </div>
            </div>
            <div class="patron-card-bar">
              <b-button size="sm" variant="flat-secondary" class="btn-icon" title="Código RFID" @click="abrirRfid(p)"><i class="fa-solid fa-barcode"></i></b-button>
              <b-button size="sm" variant="flat-secondary" class="btn-icon" title="Imprimir" @click="imprimir([{ rfid: p.rfid, codigo: p.codigo, sobre: sobreActivo.nombre, patron: p.nombre }])"><i class="fa-solid fa-print"></i></b-button>
              <b-button size="sm" variant="flat-danger" class="btn-icon" title="Eliminar" @click="borrarPatron(p)"><i class="fa-solid fa-trash"></i></b-button>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-card>

    <!-- ================= MODAL DETALLE PATRÓN ================= -->
    <b-modal v-model="mostrarDetalle" size="lg" hide-footer scrollable no-fade @hidden="limpiarBackdrop"
      :title="patronActivo ? patronActivo.nombre : ''">
      <div v-if="patronActivo" class="patron-detalle">
        <!-- Fotos (PNG del patrón + foto real) + código -->
        <div class="text-center mb-2">
          <div class="d-flex flex-wrap justify-content-center" style="gap:20px">
            <div>
              <div class="small text-muted mb-25">Patrón (PNG)</div>
              <div class="patron-detalle-photo mb-1">
                <b-img v-if="patronActivo.foto" :src="fotoUrl(patronActivo.foto)" class="patron-detalle-img" />
                <div v-else class="patron-detalle-img patron-detalle-empty"><i class="fa-solid fa-scissors"></i></div>
              </div>
              <b-button size="sm" variant="outline-secondary" :disabled="ocupado" @click="$refs.inputGaleria.click()">
                <i class="fa-solid fa-image mr-25"></i> {{ patronActivo.foto ? 'Cambiar PNG' : 'Subir PNG' }}
              </b-button>
              <input ref="inputGaleria" type="file" accept="image/*" class="d-none" @change="onFotoInput" />
            </div>
            <div>
              <div class="small text-muted mb-25">Foto real</div>
              <div class="patron-detalle-photo mb-1">
                <b-img v-if="patronActivo.fotoReal" :src="fotoUrl(patronActivo.fotoReal)" class="patron-detalle-img" />
                <div v-else class="patron-detalle-img patron-detalle-empty"><i class="fa-solid fa-camera"></i></div>
              </div>
              <b-button size="sm" variant="outline-secondary" :disabled="ocupado" @click="$refs.inputReal.click()">
                <i class="fa-solid fa-camera mr-25"></i> {{ patronActivo.fotoReal ? 'Cambiar foto real' : 'Subir foto real' }}
              </b-button>
              <input ref="inputReal" type="file" accept="image/*" class="d-none" @change="onFotoRealInput" />
            </div>
          </div>
          <div class="mt-1">
            <code class="h5">{{ patronActivo.codigo }}</code>
            <b-button size="sm" variant="flat-secondary" class="btn-icon ml-50" title="Imprimir patrón"
              @click="imprimir([{ rfid: patronActivo.rfid, codigo: patronActivo.codigo, sobre: sobreActivo.nombre, patron: patronActivo.nombre }])">
              <i class="fa-solid fa-print"></i>
            </b-button>
          </div>
        </div>

        <!-- Anotaciones -->
        <div class="patron-section mt-2">
          <h6 class="mb-1"><i class="fa-solid fa-note-sticky mr-50 text-primary"></i>Anotaciones</h6>
          <b-form-textarea v-model="nuevaAnotacion" placeholder="Escribe una anotación... (varias líneas permitidas)"
            rows="3" max-rows="10" class="mb-50" />
          <div class="text-right mb-1">
            <b-button size="sm" variant="primary" :disabled="ocupado || !nuevaAnotacion.trim()" @click="addAnotacion">
              <i class="fa-solid fa-plus mr-25"></i> Añadir nota
            </b-button>
          </div>
          <div v-if="patronActivo.anotaciones.length === 0" class="text-muted small">Sin anotaciones.</div>
          <div v-for="a in patronActivo.anotaciones" :key="a.id" class="patron-nota mb-50">
            <template v-if="editandoNotaId === a.id">
              <b-form-textarea v-model="editandoNotaTexto" rows="2" max-rows="10" class="mb-50" />
              <div class="text-right">
                <b-button size="sm" variant="flat-secondary" class="mr-50" @click="cancelarEditarNota">Cancelar</b-button>
                <b-button size="sm" variant="primary" :disabled="ocupado || !editandoNotaTexto.trim()" @click="guardarNota(a)">Guardar</b-button>
              </div>
            </template>
            <template v-else>
              <div class="d-flex align-items-start">
                <div class="patron-nota-texto flex-grow-1">{{ a.texto }}</div>
                <b-button size="sm" variant="flat-secondary" class="btn-icon ml-50" title="Editar" @click="editarNota(a)"><i class="fa-solid fa-pen"></i></b-button>
                <b-button size="sm" variant="flat-danger" class="btn-icon" title="Eliminar" @click="borrarAnotacion(a)"><i class="fa-solid fa-xmark"></i></b-button>
              </div>
              <small class="text-muted">{{ a.usuarioNombre || '' }}<span v-if="a.createdAt"> · {{ formatFechaNota(a.createdAt) }}</span></small>
            </template>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- ================= MODAL NUEVO/EDITAR SOBRE ================= -->
    <b-modal v-model="mostrarSobreForm" no-fade @hidden="limpiarBackdrop" :title="sobreEdit ? 'Editar sobre' : 'Nuevo sobre'" @ok.prevent="guardarSobre" :ok-disabled="ocupado || !sobreNombre.trim()" ok-title="Guardar" cancel-title="Cancelar">
      <b-form-group label="Nombre">
        <b-form-input v-model="sobreNombre" autofocus @keyup.enter="guardarSobre" />
      </b-form-group>
      <b-form-group label="Imagen (opcional)">
        <div class="text-center">
          <div class="patron-detalle-photo mb-1">
            <b-img v-if="sobreFotoPreview" :src="sobreFotoPreview" class="patron-detalle-img" />
            <div v-else class="patron-detalle-img patron-detalle-empty"><i class="fa-solid fa-folder-open"></i></div>
          </div>
          <b-button size="sm" variant="outline-secondary" @click="$refs.inputSobreFoto.click()">
            <i class="fa-solid fa-image mr-25"></i> {{ sobreFotoPreview ? 'Cambiar imagen' : 'Subir imagen' }}
          </b-button>
          <input ref="inputSobreFoto" type="file" accept="image/*" class="d-none" @change="onSobreFotoInput" />
        </div>
      </b-form-group>
    </b-modal>

    <!-- ================= MODAL CÓDIGO RFID ================= -->
    <b-modal v-model="mostrarRfid" no-fade @hidden="limpiarBackdrop" title="Código RFID" hide-footer>
      <div v-if="rfidItem">
        <div class="mb-1">
          <small class="text-muted">Código</small>
          <div><code class="h5">{{ rfidItem.codigo }}</code></div>
        </div>
        <div class="mb-1">
          <small class="text-muted">RFID · 128 bits (32 hex)</small>
          <b-input-group>
            <b-form-input :value="rfidItem.rfid" readonly class="text-monospace" />
            <b-input-group-append>
              <b-button variant="outline-primary" @click="copiar(rfidItem.rfid)"><i class="fa-solid fa-copy"></i></b-button>
            </b-input-group-append>
          </b-input-group>
        </div>
        <div>
          <small class="text-muted">RFID · 96 bits (24 hex)</small>
          <b-input-group>
            <b-form-input :value="rfid96(rfidItem.rfid)" readonly class="text-monospace" />
            <b-input-group-append>
              <b-button variant="outline-primary" @click="copiar(rfid96(rfidItem.rfid))"><i class="fa-solid fa-copy"></i></b-button>
            </b-input-group-append>
          </b-input-group>
        </div>
      </div>
    </b-modal>

    <!-- ================= MODAL FORMATO RFID (al imprimir) ================= -->
    <b-modal v-model="mostrarFormato" no-fade @hidden="limpiarBackdrop" title="Imprimir etiquetas" @ok="confirmarImprimir" ok-title="Imprimir">
      <div class="text-center mb-1">
        <small class="text-muted d-block mb-50 font-weight-bold text-uppercase">Vista previa</small>
        <div class="patron-preview-box">
          <img v-if="previewPatron" :src="previewPatron" class="patron-preview-img" />
          <b-spinner v-else-if="cargandoPreview" variant="primary" small />
          <span v-else class="text-muted small">Sin vista previa</span>
        </div>
        <small v-if="etiquetasPendientes.length > 1" class="text-muted d-block mt-50">{{ etiquetasPendientes.length }} etiquetas · se muestra la primera</small>
      </div>
      <b-form-group label="Tipo de etiqueta" class="mb-1">
        <b-form-radio-group v-model="tipoImpresion" buttons button-variant="outline-primary">
          <b-form-radio value="corte"><i class="fa-solid fa-scissors mr-25"></i> Corte</b-form-radio>
          <b-form-radio value="mano"><i class="fa-solid fa-warehouse mr-25"></i> Mano</b-form-radio>
        </b-form-radio-group>
      </b-form-group>
      <b-form-group label="Formato RFID" class="mb-0">
        <b-form-radio-group v-model="formatoBits" stacked>
          <b-form-radio :value="128">128 bits (32 hex)</b-form-radio>
          <b-form-radio :value="96">96 bits (24 hex)</b-form-radio>
        </b-form-radio-group>
      </b-form-group>
    </b-modal>

    <!-- ================= MODAL IMPRESORA RFID ================= -->
    <b-modal v-model="mostrarImpresora" no-fade @hidden="limpiarBackdrop" title="Impresora RFID"
      @ok.prevent="guardarImpresora" :ok-disabled="ocupado || !impresoraForm.host.trim()" ok-title="Guardar" cancel-title="Cerrar">
      <b-form-group label="IP de la impresora">
        <b-form-input v-model="impresoraForm.host" placeholder="192.168.1.96" autofocus />
      </b-form-group>
      <b-form-group label="Puerto">
        <b-form-input v-model.number="impresoraForm.port" type="number" placeholder="9100" />
        <small class="text-muted">Zebra ZPL raw: normalmente 9100.</small>
      </b-form-group>
      <div class="d-flex align-items-center">
        <b-button variant="outline-primary" size="sm" :disabled="probando || !impresoraForm.host.trim()" @click="probarImpresora">
          <b-spinner v-if="probando" small class="mr-25" />
          <i v-else class="fa-solid fa-plug mr-25"></i> Probar conexión
        </b-button>
        <span v-if="testResultado" class="ml-1 small" :class="testResultado.ok ? 'text-success' : 'text-danger'">
          <i class="fa-solid mr-25" :class="testResultado.ok ? 'fa-circle-check' : 'fa-circle-xmark'"></i>
          <template v-if="testResultado.ok">Conectada{{ testResultado.nombre ? ` · ${testResultado.nombre}` : '' }}</template>
          <template v-else>{{ testResultado.error || 'Sin conexión' }}</template>
        </span>
      </div>
    </b-modal>

    <!-- ================= MODAL NUEVO PATRÓN ================= -->
    <b-modal v-model="mostrarPatronForm" no-fade @hidden="limpiarBackdrop" title="Nuevo patrón" @ok.prevent="guardarPatron" :ok-disabled="ocupado || !patronNombre.trim()" ok-title="Guardar" cancel-title="Cancelar">
      <b-form-group label="Nombre">
        <b-form-input v-model="patronNombre" autofocus />
      </b-form-group>
      <b-form-group label="Fotos (opcional)">
        <div class="d-flex flex-wrap justify-content-center text-center" style="gap:20px">
          <div>
            <div class="small text-muted mb-25">Patrón (PNG)</div>
            <div class="patron-detalle-photo mb-1">
              <b-img v-if="patronFotoPreview" :src="patronFotoPreview" class="patron-detalle-img" />
              <div v-else class="patron-detalle-img patron-detalle-empty"><i class="fa-solid fa-scissors"></i></div>
            </div>
            <b-button size="sm" variant="outline-secondary" @click="$refs.inputPatronFoto.click()">
              <i class="fa-solid fa-image mr-25"></i> {{ patronFotoPreview ? 'Cambiar PNG' : 'Subir PNG' }}
            </b-button>
            <input ref="inputPatronFoto" type="file" accept="image/*" class="d-none" @change="onPatronFotoInput" />
          </div>
          <div>
            <div class="small text-muted mb-25">Foto real</div>
            <div class="patron-detalle-photo mb-1">
              <b-img v-if="patronFotoRealPreview" :src="patronFotoRealPreview" class="patron-detalle-img" />
              <div v-else class="patron-detalle-img patron-detalle-empty"><i class="fa-solid fa-camera"></i></div>
            </div>
            <b-button size="sm" variant="outline-secondary" @click="$refs.inputPatronFotoReal.click()">
              <i class="fa-solid fa-camera mr-25"></i> {{ patronFotoRealPreview ? 'Cambiar foto real' : 'Subir foto real' }}
            </b-button>
            <input ref="inputPatronFotoReal" type="file" accept="image/*" class="d-none" @change="onPatronFotoRealInput" />
          </div>
        </div>
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import axios from '@axios'

export default {
  data() {
    return {
      cargando: false,
      ocupado: false,
      sobres: [],
      sobreActivo: null,
      patrones: [],
      // búsqueda local
      busqueda: '',
      busquedaPatron: '',
      // modal RFID
      mostrarRfid: false,
      rfidItem: null,
      // foto en detalle
      fotoNueva: null,
      // edición de notas
      editandoNotaId: null,
      editandoNotaTexto: '',
      // detalle
      mostrarDetalle: false,
      patronActivo: null,
      nuevaAnotacion: '',
      // forms
      mostrarSobreForm: false,
      sobreEdit: null,
      sobreNombre: '',
      sobreFoto: null,
      sobreFotoPreview: '',
      mostrarPatronForm: false,
      patronNombre: '',
      patronFoto: null,
      patronFotoPreview: '',
      patronFotoReal: null,
      patronFotoRealPreview: '',
      // impresión
      mostrarFormato: false,
      formatoBits: 128,
      tipoImpresion: 'corte', // 'corte' | 'mano'
      etiquetasPendientes: [],
      previewPatron: null,   // data URL de la vista previa (Labelary)
      cargandoPreview: false,
      // impresora RFID (config en BD)
      impresora: { host: null, port: null },
      mostrarImpresora: false,
      impresoraForm: { host: '', port: 9100 },
      probando: false,
      testResultado: null,
    }
  },
  computed: {
    apiBase() {
      return axios.defaults.baseURL || ''
    },
    sobresFiltrados() {
      const q = this.busqueda.trim().toLowerCase()
      if (!q) return this.sobres
      return this.sobres.filter(s => (s.nombre || '').toLowerCase().includes(q) || (s.codigo || '').toLowerCase().includes(q))
    },
    patronesFiltrados() {
      const q = this.busquedaPatron.trim().toLowerCase()
      if (!q) return this.patrones
      return this.patrones.filter(p => (p.nombre || '').toLowerCase().includes(q) || (p.codigo || '').toLowerCase().includes(q))
    },
    tituloImpresora() {
      return this.impresora.host ? `Impresora RFID: ${this.impresora.host}` : 'Configurar impresora RFID'
    },
  },
  watch: {
    // Al cambiar Corte/Mano con el modal abierto, regenera la vista previa (cambia la C/M)
    tipoImpresion() { if (this.mostrarFormato) this.cargarPreviewPatron() },
  },
  methods: {
    fotoUrl(foto) {
      return foto ? this.apiBase + foto : null
    },
    formatFechaNota(fecha) {
      if (!fecha) return ''
      const d = new Date(fecha.replace ? fecha.replace(' ', 'T') : fecha)
      if (isNaN(d)) return ''
      return d.toLocaleString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })
    },
    toast(msg, variant = 'danger') {
      this.$bvToast.toast(msg, { title: 'Patrones', variant, solid: true })
    },
    // Workaround: a veces (móvil) el backdrop del modal se queda pegado al cerrar.
    // Si no queda ningún modal abierto, limpiamos el backdrop y el estado del body.
    limpiarBackdrop() {
      this.$nextTick(() => {
        if (document.querySelector('.modal.show')) return
        document.querySelectorAll('.modal-backdrop').forEach(el => el.remove())
        document.body.classList.remove('modal-open')
        document.body.style.removeProperty('overflow')
        document.body.style.removeProperty('padding-right')
      })
    },

    // -------- Código RFID --------
    rfid96(rfid) {
      return (rfid || '').slice(0, 24)
    },
    abrirRfid(item) {
      this.rfidItem = { codigo: item.codigo, rfid: item.rfid }
      this.mostrarRfid = true
    },
    copiar(texto) {
      const done = () => this.toast('Copiado al portapapeles', 'success')
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(texto).then(done).catch(() => this.toast('No se pudo copiar'))
      } else {
        // Fallback navegadores antiguos / contexto no seguro
        const ta = document.createElement('textarea')
        ta.value = texto
        document.body.appendChild(ta)
        ta.select()
        try { document.execCommand('copy'); done() } catch (e) { this.toast('No se pudo copiar') }
        document.body.removeChild(ta)
      }
    },

    // -------- Sobres --------
    loadSobres() {
      this.cargando = true
      axios.get('/patrones/sobres')
        .then(({ data }) => { this.sobres = data })
        .catch(() => this.toast('Error al cargar los sobres'))
        .finally(() => { this.cargando = false })
    },
    abrirNuevoSobre() {
      this.sobreEdit = null
      this.sobreNombre = ''
      this.sobreFoto = null
      this.sobreFotoPreview = ''
      this.mostrarSobreForm = true
    },
    abrirRenombrarSobre(s) {
      this.sobreEdit = s
      this.sobreNombre = s.nombre
      this.sobreFoto = null
      this.sobreFotoPreview = s.foto ? this.fotoUrl(s.foto) : ''
      this.mostrarSobreForm = true
    },
    // Redimensiona (max 1600px) y recomprime antes de subir, para que una foto de
    // cámara de 5MB no se guarde tal cual. Conserva PNG (transparencia); el resto -> JPEG.
    // Si no gana nada (ya pequeña) o algo falla, devuelve el original.
    comprimirImagen(file, maxLado = 1600, calidad = 0.72) {
      return new Promise((resolve) => {
        if (!file || !/^image\//.test(file.type)) return resolve(file)
        const esPng = /png$/i.test(file.type)
        const url = URL.createObjectURL(file)
        const img = new Image()
        img.onload = () => {
          URL.revokeObjectURL(url)
          const escala = Math.min(1, maxLado / Math.max(img.width, img.height))
          if (escala === 1 && file.size < 700 * 1024) return resolve(file)
          const canvas = document.createElement('canvas')
          canvas.width = Math.round(img.width * escala)
          canvas.height = Math.round(img.height * escala)
          canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height)
          const tipo = esPng ? 'image/png' : 'image/jpeg'
          canvas.toBlob((blob) => {
            if (!blob || blob.size >= file.size) return resolve(file) // no empeorar
            resolve(new File([blob], file.name, { type: tipo }))
          }, tipo, calidad)
        }
        img.onerror = () => { URL.revokeObjectURL(url); resolve(file) }
        img.src = url
      })
    },
    async onSobreFotoInput(e) {
      const raw = e.target.files && e.target.files[0]
      e.target.value = ''
      if (!raw) return
      const file = await this.comprimirImagen(raw)
      this.sobreFoto = file
      this.sobreFotoPreview = URL.createObjectURL(file)
    },
    guardarSobre() {
      const nombre = this.sobreNombre.trim()
      if (!nombre) return
      const fd = new FormData()
      fd.append('nombre', nombre)
      if (this.sobreFoto) fd.append('foto', this.sobreFoto)
      const req = this.sobreEdit
        ? axios.put(`/patrones/sobres/${this.sobreEdit.id}`, fd)
        : axios.post('/patrones/sobres', fd)
      this.ocupado = true
      req.then(() => { this.mostrarSobreForm = false; this.loadSobres() })
        .catch(() => this.toast('Error al guardar el sobre'))
        .finally(() => { this.ocupado = false })
    },
    borrarSobre(s) {
      this.$bvModal.msgBoxConfirm(`¿Eliminar el sobre "${s.nombre}" y todos sus patrones?`, { okVariant: 'danger', okTitle: 'Eliminar', cancelTitle: 'Cancelar' })
        .then((ok) => {
          if (!ok) return
          axios.delete(`/patrones/sobres/${s.id}`).then(() => this.loadSobres()).catch(() => this.toast('Error al eliminar'))
        })
    },
    abrirSobre(s) {
      this.sobreActivo = s
      this.busquedaPatron = ''
      this.loadPatrones()
    },
    volverSobres() {
      this.sobreActivo = null
      this.patrones = []
      this.busquedaPatron = ''
      this.loadSobres()
    },

    // -------- Patrones --------
    loadPatrones() {
      this.cargando = true
      axios.get(`/patrones/sobres/${this.sobreActivo.id}/patrones`)
        .then(({ data }) => { this.patrones = data })
        .catch(() => this.toast('Error al cargar los patrones'))
        .finally(() => { this.cargando = false })
    },
    abrirNuevoPatron() {
      this.patronNombre = ''
      this.patronFoto = null
      this.patronFotoPreview = ''
      this.patronFotoReal = null
      this.patronFotoRealPreview = ''
      this.mostrarPatronForm = true
    },
    async onPatronFotoInput(e) {
      const raw = e.target.files && e.target.files[0]
      e.target.value = ''
      if (!raw) return
      const file = await this.comprimirImagen(raw)
      this.patronFoto = file
      this.patronFotoPreview = URL.createObjectURL(file)
    },
    async onPatronFotoRealInput(e) {
      const raw = e.target.files && e.target.files[0]
      e.target.value = ''
      if (!raw) return
      const file = await this.comprimirImagen(raw)
      this.patronFotoReal = file
      this.patronFotoRealPreview = URL.createObjectURL(file)
    },
    guardarPatron() {
      const nombre = this.patronNombre.trim()
      if (!nombre) return
      const fd = new FormData()
      fd.append('nombre', nombre)
      if (this.patronFoto) fd.append('foto', this.patronFoto)
      if (this.patronFotoReal) fd.append('fotoReal', this.patronFotoReal)
      this.ocupado = true
      axios.post(`/patrones/sobres/${this.sobreActivo.id}/patrones`, fd)
        .then(() => { this.mostrarPatronForm = false; this.loadPatrones() })
        .catch(() => this.toast('Error al crear el patrón'))
        .finally(() => { this.ocupado = false })
    },
    borrarPatron(p) {
      this.$bvModal.msgBoxConfirm(`¿Eliminar el patrón "${p.nombre}"?`, { okVariant: 'danger', okTitle: 'Eliminar', cancelTitle: 'Cancelar' })
        .then((ok) => {
          if (!ok) return
          axios.delete(`/patrones/patrones/${p.id}`).then(() => this.loadPatrones()).catch(() => this.toast('Error al eliminar'))
        })
    },

    // -------- Detalle / anotaciones --------
    abrirPatron(p) {
      this.nuevaAnotacion = ''
      this.fotoNueva = null
      this.editandoNotaId = null
      axios.get(`/patrones/patrones/${p.id}`)
        .then(({ data }) => { this.patronActivo = data; this.mostrarDetalle = true })
        .catch(() => this.toast('Error al abrir el patrón'))
    },
    async onFotoInput(e) {
      const raw = e.target.files && e.target.files[0]
      e.target.value = '' // permite volver a elegir el mismo archivo
      if (raw) this.cambiarFoto(await this.comprimirImagen(raw), 'foto')
    },
    async onFotoRealInput(e) {
      const raw = e.target.files && e.target.files[0]
      e.target.value = '' // permite volver a elegir el mismo archivo
      if (raw) this.cambiarFoto(await this.comprimirImagen(raw), 'fotoReal')
    },
    cambiarFoto(file, campo = 'foto') {
      if (!file) return
      const fd = new FormData()
      fd.append(campo, file)
      this.ocupado = true
      axios.put(`/patrones/patrones/${this.patronActivo.id}`, fd)
        .then(() => { this.fotoNueva = null; this.recargarPatron(); if (this.sobreActivo) this.loadPatrones() })
        .catch(() => this.toast('Error al subir la foto'))
        .finally(() => { this.ocupado = false })
    },
    recargarPatron() {
      if (!this.patronActivo) return
      axios.get(`/patrones/patrones/${this.patronActivo.id}`).then(({ data }) => { this.patronActivo = data })
    },
    addAnotacion() {
      const texto = this.nuevaAnotacion.trim()
      if (!texto) return
      this.ocupado = true
      axios.post(`/patrones/patrones/${this.patronActivo.id}/anotaciones`, { texto })
        .then(() => { this.nuevaAnotacion = ''; this.recargarPatron() })
        .catch(() => this.toast('Error al añadir la anotación'))
        .finally(() => { this.ocupado = false })
    },
    borrarAnotacion(a) {
      axios.delete(`/patrones/anotaciones/${a.id}`).then(() => this.recargarPatron()).catch(() => this.toast('Error al eliminar'))
    },
    editarNota(a) {
      this.editandoNotaId = a.id
      this.editandoNotaTexto = a.texto
    },
    cancelarEditarNota() {
      this.editandoNotaId = null
      this.editandoNotaTexto = ''
    },
    guardarNota(a) {
      const texto = this.editandoNotaTexto.trim()
      if (!texto) return
      this.ocupado = true
      axios.put(`/patrones/anotaciones/${a.id}`, { texto })
        .then(() => { this.cancelarEditarNota(); this.recargarPatron() })
        .catch(() => this.toast('Error al editar la anotación'))
        .finally(() => { this.ocupado = false })
    },
    // -------- Impresión (pregunta el formato RFID antes de enviar) --------
    imprimir(etiquetas) {
      if (!etiquetas || etiquetas.length === 0) return
      this.etiquetasPendientes = etiquetas
      this.previewPatron = null
      this.mostrarFormato = true
      this.cargarPreviewPatron()
    },
    // Vista previa de la primera etiqueta (Labelary, 45x20). No graba nada.
    cargarPreviewPatron() {
      const e = this.etiquetasPendientes[0]
      if (!e) return
      this.cargandoPreview = true
      axios.post('/patrones/preview', { sobre: e.sobre, patron: e.patron, tipo: this.tipoImpresion })
        .then(({ data }) => { if (data && data.image) this.previewPatron = data.image })
        .catch(() => { /* el preview no es crítico para imprimir */ })
        .finally(() => { this.cargandoPreview = false })
    },
    confirmarImprimir() {
      const etiquetas = this.etiquetasPendientes
      if (!etiquetas || etiquetas.length === 0) return
      const tipoLabel = this.tipoImpresion === 'mano' ? 'Mano' : 'Corte'
      axios.post('/patrones/print', { etiquetas, bits: this.formatoBits, tipo: this.tipoImpresion })
        .then((res) => {
          const d = (res && res.data) || {}
          // El backend graba por TCP y verifica cada chip (rfid.error.response).
          if (d.fallidas > 0) {
            const detalle = (d.avisos || []).join(' · ')
            this.toast(`Grabadas ${d.grabadas}/${d.total}. Fallaron ${d.fallidas}: ${detalle}`, 'warning')
          } else {
            this.toast(`Grabadas y verificadas ${d.grabadas || etiquetas.length}/${d.total || etiquetas.length} · ${tipoLabel} (${this.formatoBits} bits)`, 'success')
          }
        })
        .catch((e) => this.toast((e.response && e.response.data && e.response.data.msg) || 'Error al imprimir'))
    },

    // -------- Impresora RFID (IP en BD, con test de conexión) --------
    cargarImpresora() {
      axios.get('/patrones/impresora')
        .then((res) => { this.impresora = (res && res.data) || { host: null, port: null } })
        .catch(() => { /* sin configurar todavía */ })
    },
    abrirImpresora() {
      this.testResultado = null
      this.impresoraForm = {
        host: this.impresora.host || '',
        port: this.impresora.port || 9100,
      }
      this.mostrarImpresora = true
    },
    probarImpresora() {
      this.probando = true
      this.testResultado = null
      axios.post('/patrones/impresora/test', { host: this.impresoraForm.host.trim(), port: this.impresoraForm.port })
        .then((res) => { this.testResultado = (res && res.data) || { ok: false } })
        .catch((e) => { this.testResultado = { ok: false, error: (e.response && e.response.data && e.response.data.error) || 'Error de conexión' } })
        .finally(() => { this.probando = false })
    },
    guardarImpresora() {
      const host = this.impresoraForm.host.trim()
      if (!host) return
      this.ocupado = true
      axios.put('/patrones/impresora', { host, port: this.impresoraForm.port })
        .then((res) => {
          this.impresora = (res && res.data) || { host, port: this.impresoraForm.port }
          this.mostrarImpresora = false
          this.toast('Impresora guardada', 'success')
        })
        .catch(() => this.toast('Error al guardar la impresora'))
        .finally(() => { this.ocupado = false })
    },
  },
  mounted() {
    this.loadSobres()
    this.cargarImpresora()
  },
}
</script>

<style lang="scss">
.patrones-container { max-width: 1200px; margin: 0 auto; }

/* Vista previa de la etiqueta (45x20) en el modal de impresión */
.patron-preview-box {
  min-height: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  background: #f6f6fa;
  border: 1px dashed #d8d6de;
  border-radius: 8px;
}
.patron-preview-img {
  max-width: 100%;
  max-height: 130px;
  background: #fff;
  padding: 4px;
  border-radius: 3px;
  box-shadow: 0 1px 6px rgba(0,0,0,.12);
  image-rendering: pixelated;
}

/* En móvil el menú horizontal no ocupa los 52px que el layout reserva en
   .app-content (padding-top: 64+52+12); compensamos para subir la card. */
@media (max-width: 767.98px) {
  .patrones-container { margin-top: -3.25rem; }
  .patrones-container > .card > .card-body { padding: 1.5rem; }
  /* Botones de la card más grandes y separados (área táctil) */
  .patron-card-bar { justify-content: space-around; padding: 6px 4px; gap: 0; }
  .patron-card-bar .btn {
    padding: 0.55rem 0.7rem;
    font-size: 1.15rem;
    line-height: 1;
  }
}

.patron-card {
  overflow: hidden;
  border: 2px solid #ebe9f1;
  transition: border-color 0.15s, box-shadow 0.15s;
}
.patron-card:hover {
  border-color: #7367f0;
  box-shadow: 0 0 0 2px rgba(115, 103, 240, 0.2);
}
.patron-card-cover { position: relative; cursor: pointer; }
.patron-card-img { width: 100%; height: 140px; object-fit: contain; display: block; background: #f8f8fb; padding: 6px; }
.patron-card-empty {
  display: flex; align-items: center; justify-content: center;
  height: 140px;
  background: linear-gradient(135deg, #f4f3ff, #eceaff);
  color: #b3aaf5; font-size: 2.8rem;
}
.patron-card-count {
  position: absolute; top: 8px; right: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
}
.patron-card-bar {
  display: flex; gap: 0;
  margin-top: auto;
  padding: 4px 6px; border-top: 1px solid #f1f0f5;
}
.patron-card-bar .btn { flex: 1 1 0; }
.min-w-0 { min-width: 0; }
.mt-25 { margin-top: 0.25rem; }
.mr-25 { margin-right: 0.25rem; }

/* ---- Modal detalle patrón (1 columna) ---- */
.patron-detalle-photo { display: flex; justify-content: center; }
.patron-detalle-img {
  max-width: 100%;
  max-height: 240px;
  object-fit: contain;
  border-radius: 8px;
  background: #fff;
  display: block;
}
.patron-detalle-empty {
  display: flex; align-items: center; justify-content: center;
  width: 240px; height: 200px;
  background: linear-gradient(135deg, #f4f3ff, #eceaff);
  color: #b3aaf5; font-size: 3rem;
}
.patron-section.mt-2 { border-top: 1px solid #f1f0f5; padding-top: 1rem; }
.patron-acordeon-head {
  display: flex; align-items: center;
  cursor: pointer; user-select: none;
}
.patron-acordeon-head:hover h6 { color: #7367f0; }
.patron-pegatina {
  display: flex; align-items: center; gap: 4px;
  padding: 0.4rem 0.6rem; margin-bottom: 0.4rem;
  border: 1px solid #ebe9f1; border-radius: 8px;
}
.patron-nota {
  background: #f8f8fb; border: 1px solid #f1f0f5;
  border-radius: 8px; padding: 0.5rem 0.7rem; font-size: 0.9rem;
}
.patron-nota-texto { white-space: pre-wrap; word-break: break-word; }
.ml-50 { margin-left: 0.5rem; }
</style>
